export const STAND_ALONE_RESULT_CONST = {
  TABS: [
    { LABEL: 'Study Purpose', URL: 'studyPurpose' },
    { LABEL: 'Study Results', URL: 'studyResults' },
    { LABEL: 'Patient Partner Engagement Strategies', URL: 'engagementStraegies' },
    { LABEL: 'Study Limitations', URL: 'studyLimitaions' },
    { LABEL: 'Additional Information / Resources', URL: 'resources' },
  ],

  LINKS: {
    EDIT: {
      LABEL: 'Edit Results',
      URL: '/result/standalone/edit/',
    },
  },

  TAB_ID: {
    PURPOSE: 'studyPurpose',
    RESULTS: 'studyResults',
    ENGAGEMENT: 'engagementStraegies',
    LIMITATIONS: 'studyLimitaions',
    RESOURCES: 'resources',
    HEALTH_CATEGORY: 'healthCategories',
  },

  SESSION_HEADERS: {
    PURPOSE: 'Study Purpose',
    RESULTS: 'Study Results',
    ENGAGEMENT: 'Patient Partner Engagement Strategies',
    LIMITATIONS: 'Study Limitations',
    RESOURCES: 'Additional Information / Resources',
    HEALTH_CATEGORY: 'Health Categories',
    INFORMATION: 'Study Information',
    LOCATION: 'Study Location',
    PI: 'Principal Investigator',
    CONTACTS: 'Primary Contacts',
  },

  LABEL: {
    PARTICIPATION_TYPE: 'Participation Type',
    COLLABORATING_ORGANIZATION: 'Collaborating Organizations',
    BC_AFFILIATION: 'BC SUPPORT Unit Affiliation',
    ENGAGEMENT_NUMBER: 'Number of Patient Partners engaged: ',
  },
};
